import { isEditableForTbnRow } from '../tools/headingTools';
import DwtEditor from '../editors/DwtEditor';
import VesselCapacityFormatter from '../formatters/VesselDwtFormatter';
import { commonRowAndCellClassRules } from '../../../../components/grid/classRules/classRules';
import NamePropertyComparator from '../../../../components/grid/comparators/NamePropertyComparator';
import defaultObjEquals from '../../../../components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '../../../../components/grid/columnDefaults/defaultSetFilterParams';

export const vesselDwtHeading = {
    colId: 'dwt',
    headerName: 'DWT',
    field: 'vessel.dwt',
    editable: isEditableForTbnRow,
    cellEditorFramework: DwtEditor,
    valueFormatter: VesselCapacityFormatter,
    comparator: NamePropertyComparator,
    equals: defaultObjEquals,
    filter: 'deadweightFilter',
    filterParams: {
        ...defaultSetFilterParams,
    },
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    hide: true,
    width: 120,
};
